import React from 'react';
import { Modal, Spinner } from "player-components";
import { useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useLocation } from "react-router-dom";
import { fetchLibrarySongsAsync, selectLibrarySongs} from '../../features/library/librarySlice';
import {createSetlistFromData, selectSetlistsSetlists} from '../../features/setlists/setlistsSlice';
import { selectUser } from '../../features/auth/authSlice';
import { useCallback } from 'react';

import { createSetlistFromQuery } from "./createSetlistFromQuery";

function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
}

export const setlistTitleExists = (title, existingSetlists) => {
  if (!title || !existingSetlists) return false;

  const normalisedTitle = title.trim().toLowerCase();

  // existingSetlists can be an array OR an object map
  const list = Array.isArray(existingSetlists)
    ? existingSetlists
    : Object.values(existingSetlists);

  return list.some(
    setlist =>
      typeof setlist?.title === "string" &&
      setlist.title.trim().toLowerCase() === normalisedTitle
  );
};

const doesSetlistAlreadyExist = (incomingSetlist, existingSetlists) => {
  // 1️⃣ ID match (strong)
  if (existingSetlists.byId?.[incomingSetlist.id]) {
    return { type: "id", existing: existingSetlists.byId[incomingSetlist.id] };
  }

  // 2️⃣ Content match (title + songs)
  const incomingSongIds =
    incomingSetlist.items?.map(i => i.songId).sort().join("|");

  const match = Object.values(existingSetlists.byId || {}).find(s => {
    const existingSongIds =
      s.items?.map(i => i.songId).sort().join("|");
    return (
      s.title === incomingSetlist.title &&
      existingSongIds === incomingSongIds
    );
  });

  if (match) {
    return { type: "content", existing: match };
  }

  return null;
};

const CreateSetlistContainer = () => {
    const setlists = useSelector(selectSetlistsSetlists);
    const librarySongs = useSelector(selectLibrarySongs);
    const query = useQuery();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const currentUser = useSelector(selectUser);

	useEffect(() => {
	  (async () => {
		console.log("CreateSetlistContainer mounted p1");


		console.log("CreateSetlistContainer mounted p1 dispatch = ", dispatch);
		console.log("CreateSetlistContainer mounted p1 currentUser = ", currentUser);
		console.log("CreateSetlistContainer mounted p1 setlists = ", setlists);
		console.log("CreateSetlistContainer mounted p1 query = ", query);


		await createSetlistFromQuery({
		  dispatch,
		  currentUser,
		  setlists,
		  query,
		});

		navigate(`/setlist/${query.get("setlistId")}`, { replace: true });
	  })();
	}, []);


	/*
    useEffect( async () => {
		// pgw 02-feb-2026
		// 

		// pgw 18-jul-2025
        const fetchedLibrarySongsRequest = await dispatch(fetchLibrarySongsAsync({startIndex: 0, limit: 600}));


        console.log('[CreateSetlist] setlists = ', setlists);

        console.log('[CreateSetlist] query = ', query);
        console.log('[CreateSetlist] title = ', query.get('title'));
        console.log('[CreateSetlist] subtitle = ', query.get('subtitle'));
        console.log('[CreateSetlist] setlistId = ', query.get('setlistId'));

        console.log('[CreateSetlist] fetchedLibrarySongsRequest = ', fetchedLibrarySongsRequest);


		const exists = setlistTitleExists(query.get('title'), setlists);

		if (exists) {
		  console.warn("Setlist with this title already exists");

		  let res = confirm("You alread have a setlist with the same name. Do you want to continue or cancel ? ")
		  console.log('res = ', res);
		  if (res) {
			  console.log("You pressed OK!");
		  } else {
			  console.log("You pressed Cancel - returning...");
			  navigate(`/library`);
			  return null;
		  }
		
		}		

        console.log('[CreateSetlist] currentUser = ', currentUser);
        if (currentUser) {
        	console.log('[CreateSetlist] CreateSetlistContainer mounted p2, currentUser = ', currentUser);

			let hasSub = currentUser?.subscribed;
        	console.log('[CreateSetlist] CreateSetlistContainer mounted p2, hasSub = ', hasSub);

			if (hasSub) {
        		console.log('[CreateSetlist] CreateSetlistContainer mounted p3 hasSub true ');
			}
			else {
        		console.log('[CreateSetlist] CreateSetlistContainer mounted p3 hasSub false ');
				// If user is not logged in, tell them
				alert('Sorry - you cannot do that unless you are logged in.')
            	navigate(`/library`);
                return null;
			}

            if (!setlists.find(setlist => setlist.id === query.get('setlistId'))) {
                const itemsParam = query.get('items') || '';
                const itemsArray = itemsParam ? itemsParam.split(',') : [];

                // pgw 01-feb-2026: setlist share can include per-item settings as a base64url JSON array.
                const fromBase64Url = (b64url) => {
                    if (!b64url) return null;
                    try {
                        const b64 = String(b64url).replace(/-/g, '+').replace(/_/g, '/');
                        const pad = b64.length % 4 ? '='.repeat(4 - (b64.length % 4)) : '';
                        const json = decodeURIComponent(escape(atob(b64 + pad)));
                        return JSON.parse(json);
                    } catch (e) {
                        console.warn('[CREATE SETLIST] failed to decode settings param', e);
                        return null;
                    }
                };

                const settingsParam = query.get('settings');
                const decodedSettings = fromBase64Url(settingsParam);

        	console.log('[CreateSetlist] CreateSetlistContainer decodedSettings = ', decodedSettings);

                const settingsByIx = Array.isArray(decodedSettings) ? decodedSettings : null;

                const songsById = new Map((fetchedLibrarySongsRequest.payload || []).map(s => [s.songId, s]));
                const itemsOrdered = itemsArray
                    .map((id, ix) => {
                        const song = songsById.get(id);
                        if (!song) return null;
                        return {
                            ...song,
                            ix,
                            itemSettings: settingsByIx?.[ix] || null
                        };
                    })
                    .filter(Boolean);

        	console.log('[CreateSetlist] CreateSetlistContainer itemsOrdered = ', itemsOrdered);



                await dispatch(createSetlistFromData({
                    setlistId: query.get('setlistId'),
                    title: query.get('title'),
                    subtitle: query.get('subtitle'),
                    imageUrl: atob(query.get('imageUrl')),
                    items: itemsOrdered,
                    readOnly: true
                }));
            }
            navigate(`/setlist/${query.get('setlistId')}`, {replace: true});
        }
		else {
			// pgw 02-feb-2026
			// If user is not logged in, tell them
			alert('Sorry - you cannot do that unless you are logged in.')
		}

    }, []);
	*/


    return <div className="flex justify-center mt-4 mb-4">
        <Spinner />
        
    </div>
}

export default CreateSetlistContainer;